import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getTermsAgreementsService } from '@musinsa/services-curator';

export const agreementFactory = createQueryKeys('terms', {
  agreements: () => ({
    queryKey: ['agreements'],
    queryFn: () => getTermsAgreementsService(),
  }),
});
